// Module
var code = `<div id="recent-error-details" class="modal-dialog modal-lg" role="document">
    <div class="modal-content force-text-wrap-word" tabindex="-1">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <div data-bind="with: recentError">
                <h3 class="modal-title" id="myModalLabel" data-bind="text: title, attr: { class: headerClass }"></h3>
                <div class="notification-time" data-bind="text: displayDate().format('LLL')"></div>
            </div>
        </div>
        <div class="modal-body" data-bind="with: recentError">
            <div data-bind="html: longerMessage"></div>
            <div class="d-flex margin-top" data-bind="visible: details">
                <div class="flex-grow"></div>
                <button class="btn btn-default btn-sm" data-bind="click: \$parent.copyErrorDetails"><i class="icon-copy-to-clipboard"></i><span>Copy error message</span></button>
            </div>
            <pre class="d-flex error-messages position-relative" data-bind="visible: details">
                <code data-bind="text: details"></code>
            </pre>
        </div>
        <div class="modal-footer">
            <div class="flex-horizontal">
                <div>
                    <a class="btn btn-info" href="https://issues.hibernatingrhinos.com/issues/RavenDB" target="_blank">
                        <i class="icon-bug"></i> <span>Bug tracker</span>
                    </a>
                </div>
                <div class="flex-separator"></div>
                <div>
                    <button type="button" class="btn btn-default" data-bind="click: close" title="Close this dialog">
                        <i class="icon-cancel"></i><span>Close</span>
                    </button>
                    <button type="button" class="btn btn-primary" data-bind="click: dismiss" title="Dismiss this alert">
                        <i class="icon-dismiss-all"></i><span>Dismiss alert</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
`;
// Exports
export default code;